export const environment = {
    production: false,
     apiUrl: 'https://fichepresence.oneci.ci/api/api-fiche-presence/'
    //apiUrl: 'https://fiche-de-presence.dev02.ovh.smile.ci/api-fiche-presence/'
};